import React, { useState } from 'react';
import { Row, Col } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CaretLeftFilled, CaretRightFilled } from '@ant-design/icons';
import '../../assets/css/ponentes.css';
import { Link } from 'react-router-dom';

import panel_1 from '../../assets/images/2023/paneles/Ies_Panel1.jpg';
import panel_1_en from '../../assets/images/2023/paneles/Ies_Panel1_ENG.jpg';
import panel_2 from '../../assets/images/2023/paneles/Ies_Panel2.jpg';
import panel_2_en from '../../assets/images/2023/paneles/Ies_Panel2_ENG.jpg';


import panel_1_movil from '../../assets/images/2023/paneles/Ies_Panel1_Movil.jpg';
import panel_1_en_movil from '../../assets/images/2023/paneles/Ies_Panel1_ENG_movil.jpg';
import panel_2_movil from '../../assets/images/2023/paneles/Ies_Panel2_movil.jpg';
import panel_2_en_movil from '../../assets/images/2023/paneles/Ies_Panel2_ENG_movil.jpg';

const CarouselPanel = (props) => {

  const ref_carousel = React.createRef();
  const [activar_carouse, setActivaCarosel] = useState(0);
  const {idioma} = props;
  const [select_persona, setSelectPersona] = useState(0);
  const [ver_modal, setVerModal] = useState(false);

    function SampleNextArrow(props) {
      const { className, style, onClick } = props;
      return (
        
        <CaretRightFilled className={className} style={{ ...style, display: "block", color:'white', fontSize:'34px', zIndex:'2', right:'15px' }} onClick={onClick} />
      );
    }
    function SamplePrevArrow(props) {
      const { className, style, onClick } = props;
      return (
        <CaretLeftFilled className={className} style={{ ...style, display: "block", color:'white', fontSize:'34px', zIndex:'2', left:'10px' }} onClick={onClick} />
      );
    }

    const settingsPonentes = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      arrows:true,
      nextArrow:<SampleNextArrow /> ,
      prevArrow:<SamplePrevArrow  />,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 760,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        }
      ]
    };

    const settingslogos = {
            infinite: true,
            pauseOnHover:false,
            slidesToScroll: 1,
            autoplay:true,
            arrows:false,
            autoplaySpeed: 10000,
            speed:2000,
            dots: false,
            adaptiveHeight: true
    };

    return (
      <>
      <Row justify="center" align="middle" className=''>
       
          <Col span={24}>
          </Col>
        <Col xs={0} md={24}>
        <Slider ref={ref_carousel} {...settingsPonentes} style={{margin:'0px', padding:'0px'}} className="">
        <div>
        <Link to="/panel/#evolucion-del-diseno"><img src={idioma === 'es' ? panel_1 : panel_1_en } style={{width:'100%'}} /></Link>
        </div>
        <div>
        <Link to="/panel/#presente-y-futuro"><img src={idioma === 'es' ? panel_2 : panel_2_en } style={{width:'100%'}} /></Link>
        </div>
        </Slider>
        <br /><br />
        </Col>
        <Col xs={24} md={0}>
        <Slider ref={ref_carousel} {...settingsPonentes} style={{margin:'0px', padding:'0px'}} className="">
        <div>
        <Link to="/panel/#evolucion-del-diseno"><img src={idioma === 'es' ? panel_1_movil : panel_1_en_movil } style={{width:'100%'}} /></Link>
        </div>
        <div>
        <Link to="/panel/#presente-y-futuro"><img src={idioma === 'es' ? panel_2_en : panel_2_en_movil } style={{width:'100%'}} /></Link>
        </div>
        </Slider>
        <br /><br />
        </Col>
      </Row>
    </>
    );

};

export default CarouselPanel;